import React from 'react'
import { Heading, Text } from '../components/ui'

const Manutencao: React.FC = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-gray-50 dark:bg-gray-900">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -left-32 -top-32 h-96 w-96 rounded-full bg-primary-500/10 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-primary-400/10 blur-3xl" />
        <div
          className="absolute inset-0 opacity-[0.35] dark:opacity-[0.15]"
          style={{
            backgroundImage:
              'radial-gradient(circle at 1px 1px, rgb(0 139 149 / 0.12) 1px, transparent 0)',
            backgroundSize: '28px 28px',
          }}
        />
      </div>

      <div className="relative flex min-h-screen items-center justify-center px-4 py-10 sm:px-6 lg:px-8">
        <div className="w-full max-w-[46.2rem] animate-fade-in">
          <div className="overflow-hidden rounded-2xl bg-white shadow-strong ring-1 ring-gray-200/80 dark:bg-gray-800 dark:ring-white/10">
            <div className="grid lg:grid-cols-2 lg:items-stretch">
              <div className="relative flex flex-col items-center justify-center overflow-hidden border-b border-gray-100 bg-[#008b95] px-4 py-10 sm:px-6 sm:py-12 lg:border-b-0 lg:border-r lg:py-10 dark:border-gray-700/80">
                <div
                  aria-hidden
                  className="pointer-events-none absolute inset-0 animate-robot-glow motion-reduce:animate-none"
                  style={{
                    background:
                      'radial-gradient(circle at 50% 40%, rgba(255,255,255,0.25) 0%, transparent 65%)',
                  }}
                />
                <div className="relative w-full max-w-[240px] animate-robot-boot opacity-0 motion-reduce:animate-none motion-reduce:opacity-100 sm:max-w-[280px] lg:max-w-none">
                  <img
                    src="/Logo_QG_PASI-01.png"
                    alt="PASI QG Logo"
                    className="h-auto w-full object-contain"
                  />
                  <span className="pointer-events-none absolute left-[41.34%] top-[35.7%] h-[5.49%] w-[5.1%] origin-center rounded-full bg-[#008b95] animate-robot-blink motion-reduce:hidden" />
                  <span className="pointer-events-none absolute left-[53.18%] top-[35.7%] h-[5.49%] w-[5.1%] origin-center rounded-full bg-[#008b95] animate-robot-blink motion-reduce:hidden" />
                </div>
              </div>

              <div className="flex flex-col justify-center px-5 py-8 sm:px-8 sm:py-10">
                <img
                  src="/manutencao.png"
                  alt=""
                  className="mx-auto mb-5 h-auto w-full max-w-[180px] object-contain sm:max-w-[200px]"
                />
                <Heading as="h1" size="2xl">
                  Voltamos em breve
                </Heading>
                <Text size="lg" color="muted" className="mt-4">
                  Estamos fazendo uma atualização rápida no PASI QG. Logo você poderá acessar novamente.
                </Text>
                <Text size="sm" color="muted" className="mt-6">
                  Agradecemos a compreensão.
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Manutencao
